import type { ColumnId, RowId } from '../../common/types/index.tsx';
import { createIsCellHovered } from './cells.tsx';
import { createHigherLevelHook } from './utils.tsx';

export const useIsCellHovered = createHigherLevelHook<boolean, [RowId, ColumnId]>(
	createIsCellHovered,
);
